import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useParams } from 'react-router';
import Slider from 'react-slick';
import { TournamentConfig } from 'common/dist/infrastructure/modules/game/interfaces/TournamentTypes';

import { useGetTournamentsForLocation } from 'targets/web/modules/display/hooks/useGetTournamentsForLocation';
import { TournamentCardBody } from 'targets/web/modules/display/components/tournament/TournamentCardBody/TournamentCardBody';
import { TournamentCardFooter } from 'targets/web/modules/display/components/tournament/TournamentCardFooter/TournamentCardFooter';
import { TournamentCardHeader } from 'targets/web/modules/display/components/tournament/TournamentCardHeader/TournamentCardHeader';

const sliderSettings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 15000,
  pauseOnHover: false,
  adaptiveHeight: true,
};

export const TournamentsView: FC = () => {
  const { locationName } = useParams<{ locationName: string }>();
  const { isLoading, tournaments } = useGetTournamentsForLocation(locationName);

  const contentJustification = isLoading ? 'center' : 'flex-start';

  return (
    <Stack
      width="100%"
      minHeight="100vh"
      justifyContent={contentJustification}
      alignItems="center"
      pt={4}
      sx={{ bgcolor: 'background.default' }}>
      {isLoading ? (
        <Stack justifyContent="center" alignItems="center" spacing={2}>
          <CircularProgress size={100} />
          <Typography sx={{ fontSize: 56, fontFamily: 'RawsonBlack' }}>Loading...</Typography>
        </Stack>
      ) : (
        <Stack width="100%" maxWidth={1080} px={2} flex={1}>
          <TournamentCardHeader />
          <Slider {...sliderSettings}>
            {tournaments.map((t: TournamentConfig) => (
              <Box
                key={t.id}
                sx={{
                  width: '100%',
                  boxSizing: 'border-box',
                }}>
                <TournamentCardBody tournament={t} />
              </Box>
            ))}
          </Slider>
          <TournamentCardFooter />
        </Stack>
      )}
    </Stack>
  );
};
